import React from 'react';
import { Tabs } from 'antd';
import { LayoutDashboard, Wallet, IndianRupee } from 'lucide-react';
import OverviewTab from './OverviewTab';
import BudgetActualsTab from './BudgetActualsTab';
import CashCollectedTab from './CashCollectedTab';

const FinanceIndex = () => {
  const items = [
    {
      key: 'overview',
      label: (
        <span className="flex items-center gap-2">
          <LayoutDashboard className="w-4 h-4" />
          Overview
        </span>
      ),
      children: <OverviewTab />,
    },
    {
      key: 'budget-actuals',
      label: (
        <span className="flex items-center gap-2">
          <Wallet className="w-4 h-4" />
          Budget & Actuals
        </span>
      ),
      children: <BudgetActualsTab />,
    },
    {
      key: 'cash-collected',
      label: (
        <span className="flex items-center gap-2">
          <IndianRupee className="w-4 h-4" />
          Cash Collected
        </span>
      ),
      children: <CashCollectedTab />,
    },
  ];

  return (
    <div className="p-6 bg-background min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Finance</h1>
        <p className="text-sm text-muted-foreground">Overview, budget tracking, and cash collected</p>
      </div>
      <Tabs
        defaultActiveKey="overview"
        items={items}
        size="large"
        className="finance-tabs"
        tabBarStyle={{
          backgroundColor: 'hsl(var(--card))',
          borderRadius: 16,
          padding: '4px 8px',
          border: '1px solid hsl(var(--border))',
          marginBottom: 24,
        }}
      />
    </div>
  );
};

export default FinanceIndex;
